import {
  Component,
} from "react";
import {
  Link,
} from "react-router-dom";

import Breadcrumb from "CommonComponents/breadcrumb";
import store from "CommonState/store";

@store("user")
export default class DatenschutzPage extends Component {
  render() {
    return <div id="wrapper">
      <Breadcrumb name='Datenschutz' path='/datenschutz'/>
      <div className='text-center'>
        {this.props.mitHeader && <h3>Datenschutz</h3>}
        <h3>Informationen zum Schutz Ihrer persönlichen Daten</h3>
      </div>


      <h3>Funktionsbeschreibung E-Portal</h3>
      <p>Über das e-Portal können Sie den Antrag auf Ihre Beschäftigung an der Bergischen Universität und damit zusammenhängende Verwaltungsleistungen elektronisch abwickeln. Hierzu werden personenbezogene Daten von Ihnen benötigt. Wenn Sie auf unseren Seiten einen Antrag auf Beschäftigung stellen benötigen wir Ihre persönlichen Daten zur Erstellung des Einstellungsantrags sowie der dazugehörigen notwendigen Dokumente. Aufgrund dieser Angaben können wir Ihren Auftrag bearbeiten und Sie gegebenenfalls für Rückfragen kontaktieren.</p>

      <p>Die rechtlichen Grundlagen für die Verarbeitung Ihrer personenbezogenen Daten finden sich insbesondere in der Datenschutzgrundverordnung (DSGVO) sowie im Landesdatenschutzgesetz NRW (LDSG NW). </p>

      <br />

      <h4>Verantwortliche Person im Sinne der Datenschutzgrundverordnung für das e-Portal ist:</h4>

      Sabine Heinrich<br />
      Gaußstraße 20<br />
      42119 Wuppertal<br />
      Deutschland<br />
      Tel.: 0202 439 – 2191<br />
      { this.props.user && <span>E-Mail: <a href='mailto:sheinrich@uni-wuppertal.de'>sheinrich@uni-wuppertal.de</a><br /></span> }
      Website: <Link to='www.uni-wuppertal.de'>www.uni-wuppertal.de</Link><br />

      <br />

      <h3>Datenerhebung</h3>
      <h4>Bestandsdaten</h4>

      <p>Bestandsdaten sind personenbezogene Daten, durch welche die Identität der Nutzerin bzw. des Nutzers festgestellt werden kann bzw. die für die Erstellung und Bearbeitung der Anträge auf Beschäftigung notwendig sind. Auf unseren e-Portal-Seiten werden die Eingabe von Vorname, Nachname, ZIM-Account (bei Studierenden der Bergischen Universität Wuppertal) bzw. E-Mail-Adresse zur Identifikation der Nutzerin bzw. des Nutzers benutzt. </p>

      <h4>Nutzungsdaten</h4>
      <p>Informationen über unseren Umgang mit Ihren Nutzungsdaten finden Sie unter <a href='https://www.uni-wuppertal.de/datenschutz/'>https://www.uni-wuppertal.de/datenschutz/</a>.</p>

      <br />

      <h3>Datenspeicherung</h3>
      <h4>Speicherort</h4>
      <p>Ihre Eingaben bzw. an uns übermittelten Daten werden auf speziell geschützten Servern gespeichert. Der Zugriff auf diese Server und die enthaltenen Daten ist nur wenigen besonders befugten Personen möglich, die mit der inhaltlichen oder technischen Betreuung der Webserver beziehungsweise mit der Bearbeitung Ihrer Anträge befasst sind. Diese Personen sind in ihren Arbeits- bzw. Dienstverträgen auf die Einhaltung der notwendigen gesetzlichen Vorschriften (u.a. Datenschutzgesetz NRW) verpflichtet worden.</p>

      <br />

      <h3>Datennutzung</h3>
      <h4>Nutzung durch die Bergische Universität Wuppertal</h4>
      <p>Wir verwenden die von Ihnen mitgeteilten Daten zur Erstellung und Abwicklung Ihrer Einstellungsanträge. </p>

      <h4>Keine Datenweitergabe an Dritte</h4>
      <p>Die Bergische Universität und die von ihr beauftragten Dienstleister sichern zu, dass die von den Benutzerinnen und Benutzern eingegebenen Daten nicht an Dritte übermittelt werden. Übermittlungen personenbezogener Daten an staatliche Einrichtungen und Behörden erfolgen nur im Rahmen gesetzlicher Vorschriften oder wenn die Weitergabe im Fall von Angriffen auf unsere Netzinfrastruktur zur Rechts- oder Strafverfolgung erforderlich ist.</p>

      <br />

      <h3>Datensicherheit</h3>
      <h4>Datenverschlüsselung durch SSL (Secure Socket Layer)</h4>
      <p>Für die sichere Übertragung Ihrer persönlichen Daten wird die SSL-Verschlüsselung genutzt, sobald Sie unsere Webseite aufrufen. Damit wird gewährleistet, dass keine dieser Daten auf dem Übertragungsweg von Unbefugten gelesen werden können. Sie erkennen verschlüsselte Seiten an dem Symbol eines geschlossenen Schlosses je nach Browsertyp unten oder oben in Ihrem Browser-Fenster und an der geänderten URL (Internetadresse). Diese beginnt dann mit "https://e-portal.uni-wuppertal.de".</p>

      <h4>Auskunftsrecht und Berichtigung, Löschung und Sperrung von Daten</h4>

      <p>Sie haben als Nutzerin bzw. Nutzer gemäß Artikel 15 DSGVO ein Recht auf Auskunft über die zu Ihrer Person gespeicherten Daten. Bitte kontaktieren Sie uns per Post unter Bergische Universität Wuppertal, Gaußstr. 20, 42119 Wuppertal.</p>

      <p>Sollten Sie die Löschung oder Sperrung Ihrer personenbezogenen Daten nach Artikel 16 f. DSGVO wünschen kontaktieren Sie uns Post unter Bergische Universität Wuppertal, Gaußstr. 20, 42119 Wuppertal. Beachten Sie aber bitte, dass die Speicherung Ihrer personenbezogenen Daten für das Studium und/oder die Beschäftigung an unserer Universität unbedingt erforderlich ist.</p>

      <p>Nutzen Sie das e-Portal zwei Jahre lang nicht, so werden Ihre personenbezogenen Daten automatisch aus dem e-Portal gelöscht.</p>

      <p>Sollten Sie mit uns per E-Mail in Kontakt treten wollen, weisen wir darauf hin, dass der Inhalt unverschlüsselter E-Mails von Dritten eingesehen werden kann. Wir empfehlen daher, vertrauliche Informationen verschlüsselt oder über den Postweg zuzusenden.</p>

      <h4>Einbeziehung, Gültigkeit und Aktualität der Datenschutzerklärung</h4>
      <p>Durch die Weiterentwicklung unserer Webseite oder die Implementierung neuer Technologien kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die Bergische Universität Wuppertal behält sich vor, die Datenschutzerklärung jederzeit mit Wirkung für die Zukunft zu ändern. Wir empfehlen Ihnen, sich die aktuelle Datenschutzerklärung von Zeit zu Zeit erneut durchzulesen.</p>

    </div>;
  }
}
